import { Bell } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const NotificationIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Bell width={size} height={size} color={color} {...rest} />;

NotificationIcon.displayName = 'NotificationIcon';

export default NotificationIcon;
